const testimonials = [
  {
    name: 'Marco Jäckel',
    role: 'Geschäftsführer, Multichannel-Vertrieb',
    company: 'Digital Emporium GmbH',
    content: 'Sven Firnrohr und sein Team begleiten uns seit der Gründung unserer Gesellschaft in 2023. Trotz massivem Wachstums und extremer Datenmengen hat man unsere Zahlen und Daten dort immer im Griff. Für uns genau der richtige Partner.',
    rating: 5,
    image: 'https://static.readdy.ai/image/535cd5cb202604744f94f7b2225e7be8/c959e73bb768647dc0b80b5545d36055.jpeg'
  },
  {
    name: 'Martin Walter',
    role: 'Geschäftsführer, Amazon FBA Seller',
    company: 'Woldoshop GmbH',
    content: 'Nach einem halben Dutzend Dienstleisterwechseln in wenigen Jahren arbeiten wir nun seit fast fünf Jahren erfolgreich und partnerschaftlich mit der Hommen Consulting und auch der Steuerberatung Hommen zusammen. Für uns ein Glücksgriff, auch auf menschlicher Ebene.',
    rating: 5,
    image: 'https://static.readdy.ai/image/535cd5cb202604744f94f7b2225e7be8/bd0cf69984d410dfab43d0b1498d3a80.png'
  },
  {
    name: 'Sebastian Lessmann',
    role: 'Geschäftsführer, Multichannel-Vertrieb',
    company: "let's build brands GmbH",
    content: 'Mit über 20 angebundenen Vertriebskanälen und diversen Zahlungsdienstleistern sind wir auf professionelle Unterstützung in der Buchführung dringend angewiesen. Bei Hommen Consulting fühlen wir uns rundum gut betreut, man versteht unsere komplexe Systemlandschaft.',
    rating: 5,
    image: 'https://static.readdy.ai/image/535cd5cb202604744f94f7b2225e7be8/a928cfb977aaa7425f8553a0c5971cb6.jpeg'
  }
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] font-semibold text-sm uppercase tracking-wider">Kundenstimmen</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2F4858] mt-4 mb-6">
            Was unsere Mandanten sagen
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Vertrauen Sie auf die Erfahrungen erfolgreicher E-Commerce Unternehmen, die mit HOMMEN Consulting wachsen und international expandieren.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-[#2F4858] text-lg">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                  <p className="text-sm text-[#FF6B35] font-medium">{testimonial.company}</p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FF6B35] text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.content}"
              </p>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-4xl font-bold text-[#FF6B35] mb-2">100+</div>
            <div className="text-gray-600 font-medium">Zufriedene Mandanten</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#FF6B35] mb-2">27</div>
            <div className="text-gray-600 font-medium">EU-Länder Expertise</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#FF6B35] mb-2">95%</div>
            <div className="text-gray-600 font-medium">Automatisierungsgrad</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#FF6B35] mb-2">24/7</div>
            <div className="text-gray-600 font-medium">Digitaler Zugriff</div>
          </div>
        </div>
      </div>
    </section>
  );
}